import React from 'react';
import { Pagination } from 'react-bootstrap';
import Icon from '../../components/Icon/Icon';

const DataTablePagination = ({ count, page, rowsPerPage, onChangePage, onChangeRowsPerPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(count / rowsPerPage); i++) {
    pageNumbers.push(i);
  }

  const paginationNumber = () => {
    if (pageNumbers.length <= 5) {
      return pageNumbers;
    } else if (pageNumbers.length > 5 && page <= 4) {
      return [1, 2, 3, 4, 5, '...', pageNumbers[pageNumbers.length - 1]];
    } else if (pageNumbers.length > 5 && page >= pageNumbers[pageNumbers.length - 4]) {
      return [1, '...', pageNumbers[pageNumbers.length - 5], pageNumbers[pageNumbers.length - 4], pageNumbers[pageNumbers.length - 3], pageNumbers[pageNumbers.length - 2], pageNumbers[pageNumbers.length - 1]];
    } else if (pageNumbers.length > 5 && page > 4 && page < pageNumbers[pageNumbers.length - 4]) {
      return [1, '...', page - 1, page, page + 1, '...', pageNumbers[pageNumbers.length - 1]];
    }
  };

  const paginationItems = paginationNumber().map((item, index) => (
    <Pagination.Item
      key={index} // Use index to ensure uniqueness
      disabled={isNaN(item)}
      className={`${page === item - 1 ? 'active' : ''}`}
      onClick={(ev) => {
        ev.preventDefault();
        onChangePage(null, item - 1);
      }}
    >
      {item}
    </Pagination.Item>
  ));

  const prevPage = () => {
    onChangePage(null, page - 1);
  };

  const nextPage = () => {
    onChangePage(null, page + 1);
  };

  // useEffect(() => {
  //   onChangeRowsPerPage({ target: { value: rowsPerPage } });
  // }, [rowsPerPage, onChangeRowsPerPage]);

  return (
    <div className="pagination-wrap">
      <Pagination className="pagination-s1 flex-wrap">
        <Pagination.Item
          disabled={page === 0}
          onClick={(ev) => {
            ev.preventDefault();
            prevPage();
          }}
        >
          <Icon name="chevron-left" />
        </Pagination.Item>
        {paginationItems}
        <Pagination.Item
          disabled={page === pageNumbers[pageNumbers.length - 1] - 1}
          onClick={(ev) => {
            ev.preventDefault();
            nextPage();
          }}
        >
          <Icon name="chevron-right" />
        </Pagination.Item>
      </Pagination>
      <div className="pagination-info small">
        Showing {rowsPerPage * page + 1} to {(count > rowsPerPage * (page + 1)) ? rowsPerPage * (page + 1) : count} of {count} entries
      </div>
    </div>
  );
};

export default DataTablePagination;
